const mediaElements = Array.from(document.querySelectorAll('audio, video'));

mediaElements.forEach((media) => {
  media.addEventListener('play', () => {
    mediaElements.forEach((otherMedia) => {
      if (otherMedia !== media && !otherMedia.paused) {
        otherMedia.pause();
      }
    });

    window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'media' } }));
  });
});
